import { Container } from 'react-bootstrap';

const CommonContainer = ({ children }: { children: React.ReactNode }) => {
  return <Container className='custom-container'>{children}</Container>;
};

export default CommonContainer;
